document.addEventListener('DOMContentLoaded', function () {


  // Replace READMORE / READLESS shortcodes in all <p> tags
  function replaceShortcodes() {
    document.querySelectorAll('p').forEach(p => {
      p.innerHTML = p.innerHTML
        .replace(/READMORE/g, '<a href="#more" class="read-more">Read More...</a>')
        .replace(/READLESS/g, '<a href="#less" class="read-less">Read Less</a>');
    });
  }


  // Set up read-more functionality across MULTIPLE paragraphs
  function setupReadMore() {
    const readMoreLinks = document.querySelectorAll('.read-more');

    readMoreLinks.forEach(readMore => {
      let current = readMore.closest('p').nextElementSibling;
      let collected = [];
      let readLess = null;

      while (current) {
        const possibleReadLess = current.querySelector('.read-less');
        if (possibleReadLess) {
          readLess = possibleReadLess;
          break;
        }

        collected.push(current);
        current = current.nextElementSibling;
      }

      if (!readLess || collected.length === 0) return;

      // Make wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'read-more-content';

      collected[0].parentElement.insertBefore(wrapper, collected[0]);

      collected.forEach(el => wrapper.appendChild(el));

      readLess.style.display = 'none';

      readMore.addEventListener('click', function (e) {
        e.preventDefault();
        wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        readMore.style.display = 'none';
        readLess.style.display = 'inline';
      });

      readLess.addEventListener('click', function (e) {
        e.preventDefault();
        wrapper.style.maxHeight = '0';
        readLess.style.display = 'none';
        readMore.style.display = 'inline';
      });
    });
  }

  // Execute
  replaceShortcodes();
  setupReadMore();

});